import type { DocMeta } from '@blocksuite/store';
import type { Collection, Filter, VariableMap } from '@pique/env/filter';

import { evalFilterList } from './filter';

export const createEmptyCollection = (
  id: string,
  data?: Partial<Omit<Collection, 'id'>>
): Collection => {
  return {
    id,
    name: '',
    filterList: [],
    allowList: [],
    ...data,
  };
};

export type PageDataForFilter = {
  meta: DocMeta;
  favorite: boolean;
  publicMode: undefined | 'page' | 'edgeless';
  attendees?: string[];
  pageTitle?: string;
};

export const filterPage = (collection: Collection, page: PageDataForFilter) => {
  if (collection.allowList.includes(page.meta.id)) {
    return true;
  }
  if (collection.filterList.length === 0) {
    return false;
  }
  return filterPageByRules(collection.filterList, [], page);
};

export const filterPageByRules = (
  filters: Filter[],
  allowList: string[],
  { meta, attendees, pageTitle }: PageDataForFilter
) => {
  if (allowList?.includes(meta.id)) {
    return true;
  }
  if (filters.length === 0) {
    return true;
  }
  const varMap = {
    Created: meta.createDate,
    Tags: meta.tags,
    Attendees: attendees ?? [],
    Title: pageTitle ? [pageTitle] : [],
  } as VariableMap;
  return evalFilterList(filters, varMap);
};
